import { schemes, zSchema } from "@zeal/common";

export const rollPreProcessingChecksAndPaymentsToPendingRequestSchema =
  zSchema.object({
    checkIDs: zSchema.array(schemes.uuid()).optional(),
    check_date: schemes.isoDate(),
    paymentIDs: zSchema.array(schemes.mongoObjectId()).optional(),
    test: zSchema.boolean(),
  });

export type TRollPreProcessingChecksAndPaymentsToPendingRequestSchema =
  zSchema.infer<
    typeof rollPreProcessingChecksAndPaymentsToPendingRequestSchema
  >;

export const rollPreProcessingChecksAndPaymentsToPendingResponseSchema =
  zSchema.object({
    reset: zSchema.object({
      checks: zSchema.number(),
      linked_checks: zSchema.number(),
      payments: zSchema.number(),
      unlinked_checks: zSchema.number(),
    }),
  });

export type TRollPreProcessingChecksAndPaymentsToPendingResponseSchema =
  zSchema.infer<
    typeof rollPreProcessingChecksAndPaymentsToPendingResponseSchema
  >;
